import { Component, computed, Inject } from '@angular/core';
import { ModalHeaderComponent } from '../../../molecules/modal/modal-header/modal-header.component';
import { Activity } from '../../activities/activities.types';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { activityTypeLabels } from '../../activities/activities.constants';
import { DayjsFormatPipe } from '../../../../pipes/date.pipe';

@Component({
  selector: 'app-modal-view-activity',
  imports: [ModalHeaderComponent, DayjsFormatPipe],
  templateUrl: './modal-view-activity.component.html',
})
export class ModalViewActivityComponent {
  static readonly overlayDataType: { activity: Activity };

  readonly title = computed(() =>
    this.data.activity.title === '' ? 'n/a' : this.data.activity.title
  );

  readonly description = computed(() =>
    this.data.activity.description === '' ? 'n/a' : this.data.activity.description
  );

  readonly activityTypeLabel = computed(() => activityTypeLabels[this.data.activity.type]);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: typeof ModalViewActivityComponent.overlayDataType
  ) {}
}
